import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useMediaQuery } from "@mui/material";
const getStyles = (isIphone, colorStyle) => {
  let styles = {
    backgroundColor: "#1E90FF",
    color: "#000",
    fontSize: isIphone ? 12 : 14,
    height: isIphone ? 28 : 32,
    width: isIphone ? 60 : 80,
    padding: 0,
    "&:hover": {
      color: "#F0F2F5",
      backgroundColor: "#00008B",
    },
  };
  return styles;
};

export default function AddButton(props) {
  const theme = useTheme();
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Button
      component="label"
      variant="contained"
      startIcon={<AddCircleOutlineIcon sx={{ height: "16px" }} />}
      disabled={props.disabled}
      onClick={(event) => props.onClick(event)}
      sx={getStyles(isIphone, props.colorStyle)}
    >
      {props.label}
      {/* <VisuallyHiddenInput type="file" /> */}
    </Button>
  );
}
